import React from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify'
import { withRouter } from 'react-router-dom'

import config from '../../../config'
import withPortal from '../../../modules/portal-redux/withPortal'
import {
  updatePortal,
  deletePortal,
} from '../../../modules/portal-remote/portalService'
import GeneralInfoForm from './GeneralInfoForm'
import { setPortal } from '../../../actions/portal'

const initialPortal = (portal = {}) => ({
  title: config.getLangText(),
  shortDescription: config.getLangText(),
  description: config.getLangText(),
  highlightSentence: config.getLangText(),
  openingHours: config.getLangText(),
  editorNotes: config.getLangText(),
  ...portal,
  contacts: {
    email: '',
    phone: '',
    fanpage: '',
    fbPageId: '',
    instragramId: '',
    lineId: '',
    webpage: '',
    others: config.getLangText(),
    ...portal.contacts,
  },
  location: {
    latitude: '',
    longitude: '',
    streetAddress: config.getLangText(),
    ...portal.location,
  },
  links: !_.isEmpty(portal.links) ? portal.links : [],
  tags: !_.isEmpty(portal.tags) ? portal.tags : [],
})

export function handleFullSocialLink(link) {
  return _.chain(link)
    .split('.com/')
    .last()
    .value()
}

class GeneralInfoFormContainer extends React.Component {
  constructor(props) {
    super(props)
    this.setEditing = _.debounce(this.setEditing, 500)
  }

  state = {
    isEditing: false,
  }

  componentDidUpdate(prevProps) {
    //handle isEditing condition copy in local
    if (!_.isEqual(this.props.portal, prevProps.portal)) {
      this.setState({ isEditing: true })
    }
  }

  initialValues(portal) {
    return initialPortal(portal)
  }

  handleSubmit = async (values, actions) => {
    try {
      actions.setSubmitting(true)

      values.contacts.fanpage = handleFullSocialLink(
        _.get(values, 'contacts.fanpage') || '',
      )
      values.contacts.instragramId = handleFullSocialLink(
        _.get(values, 'contacts.instragramId') || '',
      )

      const data = await updatePortal(values)
      console.log(data)
      this.props.actions.setPortal(data)
      actions.setSubmitting(false)
      this.setState({ isEditing: false })
      toast.success('success !')
    } catch (error) {
      actions.setSubmitting(false)
      toast.error(error.message)
    }
  }

  handleDelete = async () => {
    console.info('handle delete', this.props.portal._id)
    if (
      window.confirm(
        'แน่ใจที่จะลบ ' +
          _.get(this.props.portal, `title.${this.props.language}`),
      )
    )
      try {
        await deletePortal(this.props.portal)
        this.props.history.replace('/portals')
      } catch (error) {
        toast.error(error.message)
      }
  }

  setEditing = values => {
    const portalRemote = _.omit(this.props.portal, ['modifiedDate'])
    const portalLocal = _.omit(values, ['modifiedDate'])
    this.setState({ isEditing: !_.isEqual(portalRemote, portalLocal) })
  }

  handleValidate = (values, props) => {
    this.setEditing(values)
    const errors = {}
    if (!values.title[this.props.language]) {
      errors.title = {}
      errors.title = { [this.props.language]: 'Invalid Title!' }
    }
    return errors
  }

  render() {
    return (
      <GeneralInfoForm
        language={this.props.language}
        initialValues={this.initialValues(this.props.portal)}
        isEditing={this.state.isEditing}
        onValidate={this.handleValidate}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
        onExport={this.handleExport}
      />
    )
  }
}

export default compose(
  withRouter,
  withPortal,
  connect(
    ({ info: { language } }) => ({ language }),
    dispatch => ({
      actions: bindActionCreators({ setPortal: setPortal }, dispatch),
    }),
  ),
)(GeneralInfoFormContainer)



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoFormContainer.js